<template>
  <my-modal v-model:visible="visibleModel" :title="title" @save="handleSave">
    <div v-if="item">
      <my-input required v-model="item.amount" label="Эмчилгээний төлбөр"  currency />
      <my-input required v-model="item.note" type="textarea" label="Тайлбар" />
    </div>
  </my-modal>
</template>
<script>
export default {
  props: {
    id: { type: Number, default: null },
    visible: { type: Boolean, default: false }
  },
  data () {
    return {
      reseting: false,
      loading: false,
      saving: false,
      temp: {
        amount: 0,
        note: null
      },
      item: null
    }
  },
  computed: {
    title: {
      get () {
        return this.id ? 'Бүртгэл засварлах' : 'Шинээр бүртгэх'
      }
    },
    visibleModel: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.handleRefresh()
      }
    }
  },
  methods: {
    async handleRefresh () {
      try {
        this.loading = true
        if (this.id === null) {
          this.item = Object.assign({}, this.temp)
        } else {
          this.item = (await this.axios.get(`lookups/payment_amount/${this.id}`)).data
        }
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    async handleSave () {
      try {
        if (this.item.amount <= 100000) {
          this.customError('Мөнгөн дүн зөв оруулна уу.')
        }
        if (!this.item.note) {
          this.customError('Тайлбар оруулна уу.')
        }
        await this.showConfirm({ message: 'Бүртгэлийг хадгалахдаа итгэлтэй байна уу?' })
        if (this.saving) return
        this.saving = true
        const data = (await this.axios.post('lookups/payment_amount', this.item)).data
        this.$emit('saveSuccess', Object.assign({}, this.item, data))
        this.showToast('Амжилттай хадгаллаа.')
      } catch (err) {
        this.handleError(err)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
